module.exports = __webpack_public_path__ + "static/img/c1.131e3ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/center/bridge/cable/c1.png
// module id = tWZs
// module chunks = 0